import { Component, Input,OnInit, ViewChild, ElementRef} from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl,FormArray } from '@angular/forms';
import { TemplateRef } from '@angular/core';
import {AuthService}from '../../../auth-guard/auth.service';
import { MtxDialog } from '@ng-matero/extensions/dialog';
import {dataTableConfig} from '../../../shared/components/datatableconfig';
import { ReplaySubject, Subject, from } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { MatChipInputEvent } from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';

interface  locationarr{};

@Component({
    selector: 'createbooking',
    templateUrl: './createbooking.html',
   
  })
  export class createbooking implements OnInit {
    @ViewChild('bookingmdl') bookingmdl:TemplateRef<any>;
    @ViewChild('bookingalertmdl') bookingalertmdl:TemplateRef<any>;
    @ViewChild('bookingcancelmdl') bookingcancelmdl:TemplateRef<any>;
    @ViewChild('bookingchangestatusmdl') bookingchangestatusmdl:TemplateRef<any>;
    @ViewChild(dataTableConfig) tableconfig :dataTableConfig;
    @ViewChild("setfocuspickupdate") setfocuspickupdate: ElementRef;
    @Input('pagedtl') pagedtl:any;
    accesstring = {btndelete: 0, btnexport: 0, btnprint: 0, btnsave: 0, btnupdate: 0, btnview: 0}
  
    bccemail:any;
    bccemailarr = [];
    booking_fdl:FormGroup;
    statusbooking_fdl:FormGroup;
    formdialog:any;
    dataTable: any;
    locationtxt:any;
     action:any;
    chassistypearr:any=[];
    shipingarr = [];
    dynamic_lable:any="BL ID";
    dynamic_lable_1:any="Container ID";
    catergory_btn:any="I";
    reset_usershipline:any;
    formval:any=0;
    
   dtOption: any = {
    "columnDefs": [
        {
            "targets": [],
            "visible": false,
            "searchable": false
        },
        { 
          targets: [1,3,4,5,6,7,8,9,10],
          className: 'dt-body-center'
        }
        
    ],
    fixedColumns:   {
        leftColumns: 1
      },
   };
   list = [];
   isLoading = true;
   dtcolumns = [];
  //  actionbtns=[{text:"<span class='material-icons ' title='Cancel Booking' style='color:red;font-weight:bold'>close</span>",class:'', action:'customaction2'}
  //               // {text:"<span class='material-icons' style='color:red;'>close</span>",class:'', action:'customaction2'}
  //             ];
  actionbtns=[{text:"<a class='' title='Cancel Booking' style='color:#FF7043;font-weight:bold;cursor:pointer'>Cancel</a>",class:'', action:'customaction2'} ];
   paramdata:any;
   userdtl:any;
   locationarr=[];
   qty:any;
   showcontainerid:boolean=false;
   shutparm_val:any;
   today:any;
   nextDay:any;
   minDate:any;
   maxDate:any;
   holidays:any=[];
   myFilter:any;
   showdepotimes:string='';
   bmtittle:any='';
   bmtxt:any='';
   showelements:boolean;
   rowdata:any;
   incr_date = 0;
   poolbookinv = [];
   ispoolcust=false;
   chipemails = [];
   readonly separatorKeysCodes: number[] = [ENTER, COMMA];
   selectsize='';
   other_loc = [];
   private _onDestroy = new Subject<void>();
    public filtered_locations: ReplaySubject<locationarr[]> = new ReplaySubject<locationarr[]>(1);
    constructor(public dialog: MtxDialog,private authservice:AuthService, private fb :FormBuilder) 
    {
      // this.initialcalling()
      this.userdtl=this.authservice.getstoragedtl();
      this.ispoolcust = (this.userdtl.user_role=='PC')?true:false;
      this.intform();
      this.intfrom_statuschange();
      this.getpickuplocation();
      
      // this.getinventory();
    //  this.getbccemails();
      this.reademails();
      if(this.ispoolcust)
      {
        this.poolemails();
      }
      if(this.userdtl.reset_flg == 'N')
      {
        var that = this;
        setTimeout(function(){
          that.createbooking();
        },100);
      }
      
      this.readBookingTrucker();
      this.booking_fdl.get('user_email').setValue(this.userdtl.user_id);
      // this.chipemails = [this.userdtl.user_id];
      this.booking_fdl.get('truckerscac').setValue(this.userdtl.customer_id);
      this.booking_fdl.get('customer_type').setValue(this.userdtl.user_role)

      if(this.userdtl.customer_id=='AIMA')
      {
        this.booking_fdl.get('truckerscac').enable();
      }
      else
      {
        this.booking_fdl.get('truckerscac').disable();
      }
        // if((['SUP','ADM']).indexOf(this.userdtl.user_role) > -1)
        // {
        //   this.actionbtns = [{text:"<span class='material-icons' style='color:#FF9800;'>edit</span>",class:'getDetails',action:'editrow'},
        //       {text:"<span class='material-icons' style='color:#1E88E5;'>email</span>",class:'', action:'customaction1'},
        //       {text:"<span class='material-icons' style='color:red;'>close</span>",class:'', action:'customaction2'}
        //   ];
        // }
        
        
    }

    initialcalling(){
      this.userdtl=this.authservice.getstoragedtl();
      this.ispoolcust = (this.userdtl.user_role=='PC')?true:false;
      this.intform();
      this.intfrom_statuschange();
      this.getpickuplocation();
      
      // this.getinventory();
      this.getbccemails();
      this.reademails();
      if(this.ispoolcust)
      {
        this.poolemails();
        
      }
      else
       {
          this.shipingarr = [{codeval:'',codetxt:''}];
        }
        this.chipemails = [];
        this.booking_fdl.get('user_email').setValue(this.userdtl.user_id);
      
      // this.readBookingTrucker();
      this.booking_fdl.get('user_email').setValue(this.userdtl.user_id);
      // this.chipemails = [this.userdtl.user_id];
      this.booking_fdl.get('truckerscac').setValue(this.userdtl.customer_id);
      this.booking_fdl.get('customer_type').setValue(this.userdtl.user_role)

      if(this.userdtl.customer_id=='AIMA')
      {
        this.booking_fdl.get('truckerscac').enable();
      }
      else
      {
        this.booking_fdl.get('truckerscac').disable();
      }
    }

    intform(){
    this.booking_fdl=this.fb.group({
        location_cd:'',
        location_cd_ctrl:'',
        truckerscac:['', [Validators.required]],
        user_email:['', [ Validators.email,Validators.required]],
        pickupdate:[new Date(), [Validators.required]],
        chassistype:'',
        containernum:'',
        comments:'',
        quantity:'',
        customer_type:'',
        BL_num:'',
        shipping_line:'',
        catergory_cd:'',
        itemsRows:this.fb.array([])
        },
      );
      
    }

    

    get dynamic_formarray()
    {
      return this.booking_fdl.get('itemsRows') as FormArray
    }

   

    addthedynamicform(val)
    {
      
      console.log(val);
       var x = parseInt(val) - parseInt(this.formval);
       console.log(this.formval);

        if(x>0)
        {
           //console.log('>zero');
        }
        else
        {
           //console.log('<zero');
          let z = Math.abs(x);
          
          for(let j=0; j < z ;  j++ )
          {
            this.dynamic_formarray.removeAt((this.formval-1)-j);
          }
         
        }
        

       for(var i=0; i< x; i++)
        {
            if(this.catergory_btn =='I')
            {
                this.dynamic_lable="BL ID";
                this.dynamic_lable_1="Container ID";
                var dynamic_filedform=  this.fb.group({
                bkg_bl_id:['',[Validators.required]],
                ctr_id:['',[Validators.required]]
                })
            }
            else
            {
                this.dynamic_lable="Booking Number";
                this.dynamic_lable_1="Container ID";
                var dynamic_filedform=  this.fb.group({
                bkg_bl_id:['',[Validators.required]],
                ctr_id:['']
                })
            }
          this.dynamic_formarray.push(dynamic_filedform);
        }

         this.formval = (this.dynamic_formarray.controls).length;

         
        //  const controls = this.booking_fdl.controls;
        // for (const name in controls) {
        //     if (controls[name].invalid) {
        //       console.log(name);
        //     }
        // }


    }

    

    getformvalues(): void 
    {
      console.log(this.booking_fdl.value);
      
    }


   category_change(val){
     
      this.catergory_btn = val;
      this.formval=0;
      // alert('cat')
      this.dynamic_formarray.clear();
      this.addthedynamicform(this.booking_fdl.get('quantity').value);
    }
    
    intfrom_statuschange(){
      this.statusbooking_fdl=this.fb.group({
          status_location:'',
          status_ord_status:''
    });
    }


    ngOnInit(){
      this.booking_fdl.get('catergory_cd').setValue('I');
      this.catergory_btn='I';
      this.other_loc=[{parm_cd: "ADMCO", parm_value: "ADM COLUMBUS DEPOT", addrtxt: null, emailaddr: "", hoursofops: ""},
                      {parm_cd: "AMECL", parm_value: "AMERICAN MARINE EXPRESS", addrtxt: null, emailaddr: "", hoursofops: ""},
                      {parm_cd: "AMEGH", parm_value: "AMERICAN MARINE EXPRESS - GH", addrtxt: null, emailaddr: ""},
                      {parm_cd: "CHIAM", parm_value: "A&M TRANSPORT", addrtxt: null, emailaddr: "", hoursofops: ""}]

     
     this.accesstring = this.authservice.getaccesiblestring(this.pagedtl.accessstring);


    }
  
    createbooking()
    {
      // this.intform();
      this.showcontainerid=false;
      this.formval=0;
      // alert('cat')
      this.dynamic_formarray.clear();

      this.booking_fdl.get('catergory_cd').setValue('I');
      this.catergory_btn='I';
      this.formdialog = this.dialog.originalOpen(this.bookingmdl, {
            width: (this.ispoolcust)?'1200px':'500px',
            disableClose:true
        });
        this.getinventory();
        if(this.ispoolcust)
        {
          this.getshiping();
        }
        else{
          this.shipingarr = [{codeval:'',codetxt:''}];
        }
        this.chipemails = [];
        this.booking_fdl.get('user_email').setValue(this.userdtl.user_id);
         
    }

    readBookingTrucker()
    {
      this.isLoading = true;
      this.paramdata={}
      this.paramdata.custid=this.userdtl.customer_id
     
      this.authservice.selectdata('getpoolbookings', this.paramdata).subscribe((resp:any) =>
      {
          if(resp.length > 0)
          { 
              this.dtcolumns = Object.keys(resp[0]);
              this.list = resp;
            //   console.log(this.list);  
              setTimeout(() => {
                this.tableconfig.ontblinit(this.tableconfig.dataTableref);
                this.isLoading = false;
              }, 1);
              
          }
          else{
            this.dtcolumns = [];
            this.list = [];
            this.isLoading = false;
          }
     },
       onerror => 
      {
        console.log("Error man"); 
        this.isLoading = false;
      });  
    }

    getpickuplocation()
    {
      this.paramdata={};
      this.paramdata.qtype  =  "PGROUP" , 
      this.paramdata.qvalue  =  "BKGLOC";
      var locurl = 'getparameterbycode';
      if(this.ispoolcust)
      {
        this.paramdata.poolcd = 'FCCP';
        locurl = 'get_pool_bkglocations';
      }
      this.authservice.selectdata(locurl, this.paramdata).subscribe((getData:any) =>
      {
          if(getData.length > 0)
          {
           
              // this.locationarr = getData;
              this.locationarr=[];
              if(this.ispoolcust)
              {
                this.locationarr = getData;
              }
              else{
                if(this.userdtl.user_location_cd==null || this.userdtl.user_location_cd=='')
                {
                  this.locationarr[0] = getData[0] ;
                  // this.controllervaluechange(this.locationarr ,'location_cd_ctrl',this.filtered_locations );
                }
                else{

                  
                  var location:any=this.userdtl.user_location_cd.split(',');
                  // console.log('loactions'+location);

                    let m=0;
                    var i=0;
                  
                    while(m<getData.length)
                    {
                          var check=1;
                          for(let j=0;j<this.userdtl.user_location_cd.split(',').length;j++)
                          {
                                
                              if(location[j]==getData[m].parm_cd)
                                  {
                                    check=0;
                                  }

                          }
                          if(check==0)
                          {
                            this.locationarr.push(getData[m]);
                            // this.controllervaluechange(this.locationarr ,'location_cd_ctrl',this.filtered_locations );
                          }
                          m++;
                    }
                    
                }
              }
              this.controllervaluechange(this.locationarr ,'location_cd_ctrl',this.filtered_locations );
              this.booking_fdl.get('location_cd').setValue(this.locationarr[0].parm_cd);
              this.readChassisType();
          }
      },
      onerror => 
      {
      console.log("Error man"); 
      });
    }

    check_location()
    {
      var index
    
      index = this.other_loc.findIndex((x)=> x.parm_cd == this.booking_fdl.get('location_cd').value );
      // this.booking_fdl.get('BL_num').setValidators([Validators.required]);
      console.log(index);
      
      if(index > -1) 
      {
        this.booking_fdl.controls['BL_num'].setValidators([Validators.required]);
      }
      else
      {
        this.booking_fdl.controls['BL_num'].clearValidators();
      }
       
      this.booking_fdl.controls['BL_num'].updateValueAndValidity();
      
    }

    readChassisType(){
      this.check_location();
    

      this.chassistypearr=[];
      this.qty=[];
      // this.getFeatureDate();
      this.getholidaysnew(this.booking_fdl.get('location_cd').value );
      this.locationtimes(this.booking_fdl.get('location_cd').value);
      this.paramdata={}
      this.paramdata.location   = this.booking_fdl.get('location_cd').value ;
      this.paramdata.poolcd = 'FCCP';
      var equrl = (this.ispoolcust)?"getpoolEquipmentsizetypes":"getEquipmentsizetypes";
      this.authservice.selectdata(equrl,this.paramdata).subscribe((getData:any) => 
      { 
        if(getData.length > 0)
        {
          if(this.booking_fdl.get('truckerscac').value == "IMCG")
          {
            for(var i=0;i<getData.length;i++)
            {
              if(getData[i].eqsz_category == 'SPL')
              {
                this.chassistypearr.push(getData[i]);
                this.booking_fdl.get('chassistype').setValue(this.chassistypearr[0].equipment_sztp);
              }
            }

          }
          else{
            this.chassistypearr = getData ;         
            this.booking_fdl.get('chassistype').setValue(getData[0].equipment_sztp);
          }
          if(this.selectsize != '')
          {
            this.booking_fdl.get('chassistype').setValue(this.selectsize);
            this.selectsize = '';
          }
          
        }
        this.readquantity();
     

      },
      onerror => 
      {
        console.log("Error man"); 
      }); 
    }

    readquantity()
    {
      this.qty = []; 
      var max_cap_val;
      for( var i=0 ; i<this.chassistypearr.length ; i++)
      {
         if(this.chassistypearr[i].equipment_sztp==this.booking_fdl.get('chassistype').value)
         {
            max_cap_val= this.chassistypearr[i].max_cap_val;
         }
      }
 
      
      if(max_cap_val>5)
      {
         max_cap_val=5;
      }
      if(this.ispoolcust)
      {
          var invindx = this.poolbookinv.findIndex(x=>x.locationcd == this.booking_fdl.get('location_cd').value);
          if(invindx > -1)
          {
            if(this.booking_fdl.get('chassistype').value == '20SL')
            {
              if(this.poolbookinv[invindx].inv_20std < max_cap_val){ max_cap_val = this.poolbookinv[invindx].inv_20std;}
            }
            else if(this.booking_fdl.get('chassistype').value == '40GN')
            {
              if(this.poolbookinv[invindx].inv_40std < max_cap_val){ max_cap_val = this.poolbookinv[invindx].inv_40std;}
            }
            else if(this.booking_fdl.get('chassistype').value == '45SL')
            {
              if(this.poolbookinv[invindx].inv_45std < max_cap_val){ max_cap_val = this.poolbookinv[invindx].inv_45std;}
            }
          }
      }
       
      for(var j=1;j<= max_cap_val ; j++)
     {
       this.qty.push(j);
     }
     if(this.qty.length > 0)
     {
        this.booking_fdl.get('quantity').setValue(this.qty[0].toString());
        this.showcontainerid=true;

       
          this.addthedynamicform(this.qty[0]);
        
          this.setfocuspickupdate.nativeElement.focus();
       

     }
     else{
      this.booking_fdl.get('quantity').setValue('');
     }
    
    //  if(this.booking_fdl.get('quantity').value == '1' ) 
    //    {
    //        this.showcontainerid=true;
    //    }
    }

    getFeatureDate(){  
    
      var disabledate = 0;   
      var cur_date=  new Date();
      var day_val=cur_date.getDay();
      var locindx = this.locationarr.findIndex(x=>(x.parm_cd == this.booking_fdl.get('location_cd').value));
      
      if(day_val == 0 || day_val  == 6) 
      // && (['CHIITP','JOTUP1','WILITP']).indexOf(this.booking_fdl.get('location_cd').value) == -1)
      {
          var check=0;
          if(day_val==0 )  
          {
            check=  (this.locationarr[locindx].sunday_off == 'N') ? 0:1;
          }
          else 
          {
            check=  (this.locationarr[locindx].saturday_off == 'N') ? 0:2;
          }
          this.today = new Date(cur_date.setDate(cur_date.getDate()+check));
          this.minDate = new Date(this.today);
          this.maxDate = new Date(this.today.setDate(this.today.getDate()+disabledate));
          this.today = this.minDate;
          
      }
      else
      {
        this.today = cur_date;
        this.minDate = new Date(this.today);
        this.maxDate = new Date(cur_date.setDate(cur_date.getDate()+disabledate)); 
      }
      this.booking_fdl.get('pickupdate').setValue(this.minDate);  
      // var loop =  new Date(this.minDate);
      // while(loop <= this.maxDate){

      //   var newDate = loop.setDate(loop.getDate() + 1);
      //   loop = new Date(newDate);
      //   if(loop.getDay() == 0 || loop.getDay() == 6)
      //   {
      //     this.maxDate = new Date(this.maxDate).setDate(new Date(this.maxDate).getDate() + 1);
      //   }
        
      // }
      // this.maxDate = new Date(this.maxDate);
      console.log(this.minDate+' - '+this.maxDate);
      
    }

    getholidays(location)
    {
          
            this.paramdata={};
          
            this.paramdata.test= 'test'  ;
            this.paramdata.location= location ;
            this.authservice.selectdata('getbookingholidays',this.paramdata).subscribe((getData:any)=>
            {
            for(var i=0 ; i<getData.length ; i++)
            {
              this.holidays.push((new Date(getData[i].holiday).getTime()));
            }
        
            this.myFilter = (d: Date): boolean => {
              d.setHours(0,0,0,0);
        // Prevent Saturday and Sunday from being selected.
              if((d.getDay() == 0 || d.getDay() == 6)&& (['CHIITP','JOTUP1','WILITP']).indexOf(this.booking_fdl.get('location_cd').value) == -1)
              {
                return false;
              }
              else if( this.holidays.indexOf(d.getTime()) > -1)
              {
                    return false;
              }
              else
              {
                    return true;
              }
          
          
            }
          },
        onerror => { 
        
                console.log("Error man"); 
                });
    }
    getholidaysnew(location)
    {
        this.minDate = new Date();  
        this.maxDate = new Date();    
        var locindx = this.locationarr.findIndex(x=>(x.parm_cd == this.booking_fdl.get('location_cd').value));       
            this.myFilter = (d: Date): boolean => {
              d.setHours(0,0,0,0);
        // Prevent Saturday and Sunday from being selected.
              // if((d.getDay() == 0 || d.getDay() == 6)&& (['CHIITP','JOTUP1','WILITP']).indexOf(location) == -1)
              // {
              //   return false;
              // }
              if(d.getDay() == 0 && (this.locationarr[locindx].sunday_off == 'Y'))
              {
                return false;
              }
              else if(d.getDay() == 6 && (this.locationarr[locindx].saturday_off == 'Y'))
              {
                return false;
              }
              else if( this.holidays.indexOf(d.getTime()) > -1)
              {
                    return false;
              }
              else
              {
                    return true;
              }
          
          
            }
         
    }

    checkshowcontainer(value){
     
        if(value >= '1' ) 
        {
          this.showcontainerid=true;
          // alert('check container');
          this.addthedynamicform(value);
        }
        else
        {
          this.showcontainerid=false;
        }

    }

    reademails()
    {
          this.paramdata={}
          this.paramdata.qtype  = "PGROUP"  ;
          this.paramdata.qvalue = "BKGEML" ;
          this.authservice.selectdata('getparameterbycode',this.paramdata).subscribe((getData:any) => 
          {
            if(getData.length>0)
            {
              this.bccemailarr = getData;
            }        
          },
        onerror => 
          {
            console.log("Error man"); 
          });
    } 

    emailsbylocation()
    { 
        var emails = this.bccemail;
        if(this.bccemailarr.length>0)
        {
          for(var i=0;i<this.bccemailarr.length;i++)
          {
              if(this.booking_fdl.get('location_cd').value==this.bccemailarr[i].parm_cd)
              {
                emails += '|'+this.bccemailarr[i].parm_value;
              }
          }
        }
        return emails;
             
    }

    poolemails()
    {
  
        this.paramdata={};
        this.paramdata.qtype="PGROUP";
        this.paramdata.qvalue="PBKEML";
        this.authservice.selectdata('getparameterbycode',this.paramdata).subscribe((getData:any)=>
        {
            for(var i=0 ; i<getData.length ; i++)
            {
                var emailval = ((getData[i].parm_value).toString()).split(',');
                for(var c=0;c<emailval.length;c++)
                {
                  this.bccemail +=  emailval[c]+'|';
                }
                 
            }
            this.bccemail = this.bccemail.slice(0, -1);
        },
        onerror => { 

                  console.log("Error man"); 
                  });
                  
    }
    getbccemails()
    {
          
                  this.paramdata={};
                  this.bccemail = "";
                  this.paramdata.qtype="PGROUP";
                  this.paramdata.qvalue="BEB";
                

            this.authservice.selectdata('getparameterbycode',this.paramdata).subscribe((getData:any)=>
            {
              if(this.bccemail.length > 0)
              {
                this.bccemail +='|';
              }
            
              for(var i=0 ; i<getData.length ; i++)
              {
                if((getData[i].parm_value).trim() != '')
                {
                  this.bccemail +=  getData[i].parm_value+'|';
                }
              }
              this.bccemail = this.bccemail.slice(0, -1);
                        console.log(this.bccemail);
            },
          onerror => { 

                      console.log("Error man"); 
                      });


                            
    }

    controllervaluechange(elementdata,ctrlname,filteredvar )
      {
        filteredvar.next(elementdata.slice());
        this.booking_fdl.get(ctrlname).valueChanges
                    .pipe(takeUntil(this._onDestroy))
                    .subscribe(() => {
                      this.filterdata(elementdata,ctrlname,filteredvar );
                    });
     }

    filterdata(elementdata,ctrlname,filteredvar)
      {

            if (! elementdata) {
                return;
              }
              // get the search keyword
              let search = this.booking_fdl.get(ctrlname).value;


              if (!search) {
                filteredvar.next( elementdata.slice());
                return;
              } else {
                search = search.toLowerCase();
              }
              // filter the sasc
                if(ctrlname=='location_cd_ctrl')
                {
                 filteredvar.next(
                    elementdata.filter(location_data => (location_data.parm_value).toLowerCase().indexOf(search) > -1)
                  );

                }
            
          
          
    }

    locationtimes(loction)
      {
        this.showdepotimes='';
        // console.log('location'+ this.locations);
        var locindx = this.locationarr.findIndex(x=>(x.parm_cd == loction));
        if(locindx > -1)
        {
          this.showdepotimes = this.locationarr[locindx].hoursofops;
        }
        else{
          this.showdepotimes = '';
        }

    }

   validate_booking()
   {
    
    this.paramdata={
      bkgjson:this.booking_fdl.value.itemsRows,   
      category_cd:this.booking_fdl.value.catergory_cd,
      shipline:this.booking_fdl.get('shipping_line').value,    
      userid:this.userdtl.user_id,
    }
   
    this.authservice.selectdata('pool_validate_bookid_ctr',this.paramdata).subscribe((response)=>{
    
     var  resdata=response[0]['responsejson'];
     
      if(this.catergory_btn=='I')
       {
        var is_valid=true ;
            for(let i=0; i< resdata.length; i++ )
            {
                   if(resdata[i]['result_cd']=='E' )
                    {
                      is_valid=false;
                      this.dynamic_formarray.controls[i].get('bkg_bl_id').setErrors({'incorrect': true});
                      this.dynamic_formarray.controls[i].get('ctr_id').setErrors({'incorrect': true});
                    

                    }
            }
            if(is_valid==true)
            {
              console.log('call booking');
              this.bookingrequest();
            }
            else
            {
              this.authservice.showToasterror('top-center','Enter valid BL ID & Container ID',5000);
            }
            
        }
        else
        {
          
           var resindx = resdata.findIndex( x =>(x.result_cd == 'S'));
           console.log(resindx);

           if(resindx > -1)
            {
              console.log('call booking');
              this.bookingrequest();
            }
            else
            {
             
                   
                this.dynamic_formarray.controls[0].get('bkg_bl_id').setErrors({'incorrect': true});
                this.dynamic_formarray.controls[0].get('bkg_bl_id').setValue('');  
                this.authservice.showToasterror('top-center','Enter atleast one valid Booking Number',5000);
            }

        }

      // this.dynamic_formarray.controls.forEach((element, index) => {
      //   console.log(element.get('bkg_bl_id').value);
      //   element.get('bkg_bl_id').setErrors({'incorrect': true});
      // });

    })
   }

   formkeyup(val)
   {
    if(this.catergory_btn =='I')
    {
    // console.log( (this.dynamic_formarray.controls[val].get('bkg_bl_id').value != "" || this.dynamic_formarray.controls[val].get('ctr_id').value == "") && (this.dynamic_formarray.controls[val].get('bkg_bl_id').value == "" || this.dynamic_formarray.controls[val].get('ctr_id').value != ""));
    if( (this.dynamic_formarray.controls[val].get('bkg_bl_id').value != "" || this.dynamic_formarray.controls[val].get('ctr_id').value == "") && (this.dynamic_formarray.controls[val].get('bkg_bl_id').value == "" || this.dynamic_formarray.controls[val].get('ctr_id').value != ""))
    {
        console.log(' 1sttrue');
        if(this.dynamic_formarray.controls[val].get('bkg_bl_id').value != "" && this.dynamic_formarray.controls[val].get('ctr_id').value != "")
        { 

          console.log('ifinneer 1sttrue');
          this.dynamic_formarray.controls[val].get('bkg_bl_id').clearValidators();
          this.dynamic_formarray.controls[val].get('bkg_bl_id').updateValueAndValidity(); 
          this.dynamic_formarray.controls[val].get('ctr_id').clearValidators();
          this.dynamic_formarray.controls[val].get('ctr_id').updateValueAndValidity();
        }
        else
        {
          console.log('ifinneer else');
          // console.log(this.dynamic_formarray.controls[val].get('bkg_bl_id').value);
            if(this.dynamic_formarray.controls[val].get('bkg_bl_id').value == "")
            {
              console.log('bl');
              this.dynamic_formarray.controls[val].get('bkg_bl_id').setErrors({'incorrect': true});
            }
           if(this.dynamic_formarray.controls[val].get('ctr_id').value == "")
            {
              console.log('con');
              this.dynamic_formarray.controls[val].get('ctr_id').setErrors({'incorrect': true});
            }
        }
       
    }
    else
    {
      console.log(' 1st lese');
      if(this.dynamic_formarray.controls[val].get('bkg_bl_id').value == "")
      {
        console.log('bl');
        this.dynamic_formarray.controls[val].get('bkg_bl_id').setErrors({'incorrect': true});
      }
      if(this.dynamic_formarray.controls[val].get('ctr_id').value == "") 
      {
         this.dynamic_formarray.controls[val].get('ctr_id').setErrors({'incorrect': true});
         console.log('con');
        
      }
      // else if(this.dynamic_formarray.controls[val].get('ctr_id').value == "")
      // {
      //   this.dynamic_formarray.controls[val].get('ctr_id').setErrors({'incorrect': true});
      // }
    }

  }

    
    
   }

    bookingrequest(){

      this.paramdata={}
      this.paramdata.customer_id   = this.booking_fdl.get('truckerscac').value ;
      this.booking_fdl.get('customer_type').setValue('MC') ;
      // this.authservice.selectdata('customertype',this.paramdata).subscribe((dataread:any) => 
      // {  
      //   this.booking_fdl.get('customer_type').setValue(dataread[0].customer_type) ;
      //   if( this.booking_fdl.get('customer_type').value =="" )
      //   {
      //     this.authservice.showToasterror('top-full-width','Trucker Role Not Selected.',2000) ; 
      //   }
      //   else 
      //   {
        this.authservice.showloader(true);
          this.paramdata={}
          this.shutparm_val='N';
          this.paramdata.truckerscac=this.booking_fdl.get('truckerscac').value;
          this.paramdata.location=this.booking_fdl.get('location_cd').value;
          for( var i=0 ; i<this.chassistypearr.length ; i++)
          {
              if(this.chassistypearr[i].equipment_sztp==this.booking_fdl.get('chassistype').value)
              {
                  this.shutparm_val= this.chassistypearr[i].shut_flg;
              }
          }
          var truckeremail = '';
          this.authservice.selectdata('getTruckDetails',this.paramdata).subscribe((dataread:any) => 
          {  
            var check=true;
            if(dataread.length>0 )
            {
                  var status=dataread[0].status_cd; 
                  truckeremail = dataread[0].trucker_email;
                  if(status=='Approved')
                  {
                      var pickupdate       = this.booking_fdl.get('pickupdate').value;
                      // var arr           = pickupdate.split('-');
                      // var arr1          = insurance.split('-');
                      var insurance        = dataread[0].insurance_exp_dt_short;
                      var fromdate         = insurance.split("-");
                      var finalconfromdate = fromdate[0] + '/' + fromdate[1] + '/' + fromdate[2];
                      // var todate           =  pickupdate.split("-");
                      // var finalcontodate   = todate[0] + '/' + todate[1] + '/' + todate[2];

                      var newfromdate     = new Date(finalconfromdate) ;
                      var newtodate       = pickupdate ;
                      var timeDiff        = (newfromdate.getTime() - newtodate.getTime()); 
                      var diffDays        = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1; 

                      if ( diffDays <= 0 )
                      {
                        check=false;
                        this.authservice.showToast_closeable('top-full-width','Your account is denied due to expired insurance, please have your insurance agent submit updated insurance to uiia@intermodal.org',80000,true,'E') ; 
                      }

                  }
                  else if(status=='Pending')
                  {
                    check=false; 
                    this.authservice.showToast_closeable('top-full-width','Trucker is not yet approved to book an AIM chassis.',10000,true,'E') ; 
                  }
                  else if(status=='Denied')
                  {
                    check=false; 
                    this.authservice.showToast_closeable('top-full-width','Your account is denied due to expired insurance, please have your insurance agent submit updated insurance to uiia@intermodal.org',20000,true,'E') ;
                  }
                  else if(status=='SHUT OFF')
                  {
                    check=false; 
                    this.authservice.showToast_closeable('top-full-width','Your account is denied due to past due invoices, please contact accountsreceviable@flexivan.com for further details',20000,true,'E') ;
                  }
                  else
                  {
                    check=false; 
                    this.authservice.showToast_closeable('top-full-width','Trucker is not yet approved to book an chassis.',10000,true,'E') ; 
                  }
            }      
          else
            {
              check=false;
              this.authservice.showToast_closeable('top-full-width','Trucker is not approved yet. Please contact Customer Service ',10000,true,'E') ;  
            }
              
            status = 'A' ;
            var str_chassistype=this.booking_fdl.get('chassistype').value;
          
          if(this.shutparm_val=='Y')
          {
            status='P'; 
          }
          var ts = new Date().getTime();
          console.log(this.emailsbylocation());
          if(this.chipemails.length == 0 && this.booking_fdl.get('user_email').value != '')
          {
            this.chipemails.push(this.booking_fdl.get('user_email').value);
            this.booking_fdl.get('user_email').setValue('');
            this.booking_fdl.get('user_email').setErrors(null);
          }
          if(check==true)
          {
            this.paramdata={};
            this.paramdata.booking_from  = "Pool Booking";
            this.paramdata.truckerscac   = this.booking_fdl.get('truckerscac').value;
            this.paramdata.pickupdate    = (this.booking_fdl.get('pickupdate').value).toLocaleDateString();
            this.paramdata.chassistype   = str_chassistype;
            this.paramdata.quantity      = this.booking_fdl.get('quantity').value;
            this.paramdata.comments      = this.booking_fdl.get('comments').value; 
            this.paramdata.customer_id   = this.userdtl.customer_id;
            this.paramdata.currentdate   = moment().subtract(7,'h').format('D-M-Y H:mm:00');
            this.paramdata.userid        = this.userdtl.user_id;                                                 
            this.paramdata.location_cd   = this.booking_fdl.get('location_cd').value;
            this.paramdata.customer_type = this.booking_fdl.get('customer_type').value;
            this.paramdata.shift_cd      = 'Day Shift';
            this.paramdata.ordernumber   = '';
            this.paramdata.ipaddress     = ''; 
            this.paramdata.status        = status;
            this.paramdata.poolcode      = 'FCCP';
            this.paramdata.shipline      = this.booking_fdl.get('shipping_line').value;
            this.paramdata.sendemail     = this.chipemails.toString();
            this.paramdata.bkgjson       = this.booking_fdl.value.itemsRows;   
            this.paramdata.category_cd   = this.booking_fdl.value.catergory_cd;


            var bookurl                  = (this.ispoolcust)?"poolbookingtruck":"bookingtrucksp";
        
            this.authservice.selectdata(bookurl,this.paramdata).subscribe((data:any)=> 
            {
              var bccemails=this.emailsbylocation();
              this.readBookingTrucker();
              
              this.formdialog.close();
              this.authservice.showloader(false);
              if(data.length>0 )
              {
                if(data[0].result_cd=='S')
              {
                //var action=action_email;
                  var action=(this.ispoolcust)?'poolbookingconformationemail':'bookingconformationemail';
                  
                  if(this.booking_fdl.get('location_cd').value=='SEACGB')
                  {
                      action='bookingconformationemail_conglobal';
                  }
                  
                  var locindx = this.locationarr.findIndex(x=>(x.parm_cd == this.booking_fdl.get('location_cd').value));
                  var szindx = this.chassistypearr.findIndex(x=>(x.equipment_sztp == this.booking_fdl.get('chassistype').value));
                  bccemails = (this.ispoolcust)?  (bccemails+'|'+(this.locationarr[locindx].emailaddr).replace(/,/g, "|")):bccemails;

                  var bookingconformation = this.authservice.getemailobjectstring({
                                                      action       : action,
                                                      emailid      : this.chipemails.toString() , 
                                                      username     : this.userdtl.first_name , 
                                                      order_nbr    : data[0].bkg_order_nbr , 
                                                      chassistype  : this.booking_fdl.get('chassistype').value , 
                                                      chassisdesc  : this.chassistypearr[szindx].description, 
                                                      quantity     : this.booking_fdl.get('quantity').value ,  
                                                      pickupdate   : moment(this.booking_fdl.get('pickupdate').value).format('DD-MMM-YYYY')  ,
                                                      truckerscac  : this.booking_fdl.get('truckerscac').value ,
                                                      bccemail     : bccemails ,
                                                      status       : status,
                                                      location     : this.booking_fdl.get('location_cd').value ,
                                                      locationaddr : (this.ispoolcust)?this.locationarr[locindx].addrtxt:'',
                                                      locationname :  this.locationarr[locindx].parm_value,
                                                      truckeremail : truckeremail,
                                                      hoursofops   : this.showdepotimes ,
                                                      ccemail      : (locindx > -1 && status=='A' )? (this.locationarr[locindx].emailaddr):'' 
                                            });
                  this.chipemails = [];
                  this.booking_fdl.get('user_email').setValue(this.userdtl.user_id);
                  if(status=='A')
                  {
                    this.authservice.showToast_closeable('top-full-width','Your Booking Confirmation Number Is : ' + data[0].bkg_order_nbr + '. Please Check Your Email For More Instructions',30000,true,'S') ; 
                  }
                  else
                  {
                    this.authservice.showToast_closeable('top-full-width','Your booking request is pending. Please check your email for more details.',15000,true,'S') ;  
                  }
                  this.authservice.sendemailurlresp('_jsbookingverification.php?',bookingconformation,'json').subscribe((getData:any) =>
                  {
        
                  },
                  onerror => {
                      console.log("Error man in bookingverfication"); 
                  });


                }
                else if(data[0].result_cd=='Q')
                {
                  this.authservice.showToasterror('top-center',data[0].result_txt,60000) ; 
                  this.chipemails = [];
                  this.booking_fdl.get('user_email').setValue(this.userdtl.user_id);
                }
                else
                {
                  this.authservice.showToast_closeable('top-full-width',data[0].result_txt,15000,true,'E') ; 
                }
              }
              else
              {
                this.authservice.showToasterror('top-full-width','Truck Not Booked ',5000) ; 
              }
            },
            onerror => 
            {
              this.formdialog.close();
              this.authservice.showToasterror('top-full-width','NOT  Booked The Truck.',5000) ;
              console.log("Error man in bookingtrucksp"); 
            });
          }
          else{
            this.authservice.showloader(false);
          }
        },
        onerror => 
        {
              console.log("Error man in TruckDetails"); 
              this.authservice.showToasterror('top-full-width','Technical error,contact customer service',7000) ; 
              this.authservice.showloader(false);
        });

      //   }
      // },
      // onerror => 
      // {
      //   console.log("Error man in customer_type"); 
      // });

  }

    openmodal_booking_satuschange(indx)
    {
       this.showelements=true;
       this.rowdata={};
       this.rowdata=this.list[indx];
       console.log(this.rowdata);
       this.intfrom_statuschange();
       this.statusbooking_fdl.get('status_location').setValue(this.rowdata.location_cd);
      this.statusbooking_fdl.get('status_ord_status').setValue(this.rowdata.status);
       this.formdialog  = this.dialog.originalOpen(this.bookingchangestatusmdl, {
        width: '400px',
       });
       
    }

    openmodal_booking_sendemail(indx)
    {
      this.showelements=false;
      this.rowdata={};
      this.rowdata=this.list[indx];
      console.log(this.rowdata.status);
     
      this.statusbooking_fdl.get('status_location').setValue(this.rowdata.location_cd);
      this.statusbooking_fdl.get('status_ord_status').setValue(this.rowdata.status);
       
        
      this.formdialog  = this.dialog.originalOpen(this.bookingchangestatusmdl, {
        width: '400px',
       });
    }

    openmodal_booking_cancel(indx)
    {
      this.rowdata={};
      this.rowdata=this.list[indx];
      console.log(this.rowdata);
      this.formdialog  = this.dialog.originalOpen(this.bookingcancelmdl, {
        width: '400px',
       });
    }
   
    booking_satuschange()
    {
      this.authservice.showloader(true);
      this.paramdata={};
      this.paramdata.order_nbr    = this.rowdata.order_nbr;
      this.paramdata.order_status = this.statusbooking_fdl.get('status_ord_status').value;
      this.paramdata.customer_id  =  this.userdtl.user_id;
      this.authservice.IUDdata('bookingtruckchangestatus',this.paramdata,'json').subscribe((data:any) => 
      {
        this.authservice.showloader(false);
        if ( data.length > 0 )
        {
            if ( data[0].result_cd = 'S' )
            {
                this.formdialog.close();
                if(this.statusbooking_fdl.get('status_ord_status').value=='A')
                {
                  this.sendEmail(this.rowdata,this.bccemail,this.rowdata.location_cd);
                }
                this.readBookingTrucker();
            }
            
        }
      },
      onerror => 
      {
        this.authservice.showloader(false);
        this.authservice.showToasterror('top-full-width','Data not Updated',2000) ;    
        
      });
    }

    booking_sendemail(){
      this.sendEmail(this.rowdata,this.bccemail,this.rowdata.location_cd)
    }

    sendEmail(result,bccemail,locationtext){
     
      var action='bookingconformationemail';
     if( this.statusbooking_fdl.get('status_location').value=='SEACGB')
      {
       action='bookingconformationemail_conglobal';
      } 
      this.paramdata={};
      this.paramdata={
                action       : action,
                emailid      : result.creater_id , 
                username     : result.trucker_cd , 
                order_nbr    : result.order_nbr , 
                chassistype  : result.eq_size , 
                quantity     : result.qty , 
                pickupdate   : result.required_date , 
                truckerscac  : result.trucker_cd , 
                bccemail     : bccemail ,
                status       : result.status,
                location     : locationtext
      }

      this.authservice.emailsending("_jsbookingverification.php", this.paramdata ).subscribe((getData:any) => 
      {
          this.authservice.showSuccess('top-full-width',' Email Sent To Customer.',2000) ; 
      },
    onerror => {
          console.log("Error man in bookingverfication"); 
      
      });
    }

    bookingcancel()
    {

      this.authservice.showloader(true);
      this.paramdata={};
      this.paramdata.order_nbr    = this.rowdata['Release Number'];
      this.paramdata.userid       =  this.userdtl.user_id;
      this.authservice.IUDdata('poolbookingcancel',this.paramdata,'json').subscribe((data:any) => 
      {
        if ( data.length > 0)
        {
            if ( data[0].result_cd == 'S' )
            {
              this.authservice.showSuccess('top-center','Booking Cancelled Successfully',5000) ; 
              this.paramdata = {};
              this.paramdata.truckerscac=this.booking_fdl.get('truckerscac').value;
              this.paramdata.location=this.booking_fdl.get('location_cd').value;
              this.authservice.selectdata('getTruckDetails',this.paramdata).subscribe((dataread:any) => 
              {  
                var bookingconformation = this.authservice.getemailobjectstring({
                    action       : 'poolbookingcancelemail',
                    emailid      : this.rowdata['Creater ID'] , 
                    order_nbr    : this.rowdata['Release Number'] , 
                    bccemail     : this.bccemail ,
                    truckeremail : '',
                });
                if(dataread.length>0 )
                {
                  var bookingconformation = this.authservice.getemailobjectstring({
                        action       : 'poolbookingcancelemail',
                        emailid      : this.rowdata['Creater ID'] , 
                        order_nbr    : this.rowdata['Release Number'] , 
                        bccemail     : this.bccemail ,
                        truckeremail : dataread[0].trucker_email,
                      });
                }
                this.authservice.sendemailurlresp('_jsbookingverification.php?',bookingconformation,'json').subscribe((getData:any) =>
                {
                },
                onerror => {
                  console.log("Error man in bookingcancel email"); 
                });
              },
              onerror => {
                  console.log("Error man in truckeremail"); 
              });
              this.readBookingTrucker();
            }
            else
            {
              this.authservice.showToasterror('top-center',data[0].result_txt,7000);
            }
            this.formdialog.close();
        }
        else
        {
          this.authservice.showToasterror('top-center','Booking Not Cancelled',5000);
        }
        this.authservice.showloader(false);
       }, 
       onerror => 
        {
          this.authservice.showloader(false); 
          
        });

    }

    getinventory()
    {
      this.paramdata={poolcode:'FCCP'};
      this.authservice.selectdata('getfccpinventory', this.paramdata).subscribe((getData:any) =>
      { 
        // console.log(getData);
        this.poolbookinv=getData;
        this.readquantity();
      },
      onerror => 
      {
      console.log("Error man"); 
      });

    }
    getshiping()
    {
      this.paramdata={}
      this.paramdata.category='FCCPSSL'; 
      var usershipline = ((this.userdtl.shippingline).toString()).split(',');
      if(this.shipingarr.length == 0 )
      {
        this.authservice.selectdata('getreferencecodes', this.paramdata).subscribe((getData:any) =>
        { 
          if(this.userdtl.customer_id=='AIMA')
          {
            this.shipingarr = getData;
          }
          else{
            this.shipingarr=getData.filter(function(data){
              return (usershipline.indexOf(data.codeval) > -1)
            });
          }
          this.reset_usershipline=usershipline[0];
          
          this.booking_fdl.get('shipping_line').setValue(usershipline[0]);
        },
        onerror => 
        {
        console.log("Error man"); 
        });
      }
      

    }
    showonbooking(dt,sz)
    {
      this.formval=0;
      // alert('cat')
      this.dynamic_formarray.clear();
      if(this.locationarr.findIndex(x=>x.parm_cd == dt.locationcd) > -1)
      {
        this.booking_fdl.get('location_cd').setValue(dt.locationcd);
        this.selectsize = sz;
      }
      
    }

    // addEmail(event: MatChipInputEvent) {
    //   const input = event.input;
    //   const value = event.value;
    //   if ((value.trim() !== '')) {
    //     this.chipemails.push(value);
    //     this.booking_fdl.controls['user_email'].markAsDirty();
    //     input.value = '';
    //   }
    // }

    addEmail(event: MatChipInputEvent) {
      const input = event.input;
      const value = event.value;
      if ((value.trim() !== '')) {
        this.booking_fdl.controls['user_email'].setErrors(null);   // 1
        const tempEmails = []; // 2
        tempEmails.push(value.trim());
        this.booking_fdl.controls['user_email'].setValue(tempEmails);     // 3
        if (this.booking_fdl.controls['user_email'].valid) {              // 4
          this.booking_fdl.controls['user_email'].markAsDirty();
          input.value = '';
          this.chipemails.push(value);                                    // 5
        } else {
          const index = this.chipemails.findIndex(value1 => value1 === value.trim());
          if (index !== -1) {
            this.chipemails.splice(index, 1);           // 6
          }
        }
      } else {
        if(this.chipemails.length > 0)
        {
          this.booking_fdl.controls['user_email'].setErrors(null);
        }
        else{
          this.booking_fdl.controls['user_email'].updateValueAndValidity();  // 7
        }
        
      }
    }
    onRemoveEmail(email: any) {
      let controller = this.booking_fdl.controls['user_email'];
      let index = this.chipemails.indexOf(email, 0);
      if (index > -1) {
        this.chipemails.splice(index, 1);
      }
      controller.markAsDirty();
    }

    resetform(){
      // this.intform();
      this.initialcalling();
      this.showcontainerid=false;
      this.formval=0;
      this.booking_fdl.get('catergory_cd').setValue('I');
      this.catergory_btn='I';
      // alert(this.reset_usershipline[0]);
     
        this.booking_fdl.get('shipping_line').setValue(this.reset_usershipline);
    }

   

    }